var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.path)?_c('div',{staticClass:"img_explain flex-col",on:{"click":function($event){return _vm.showImg(_vm.path)}}},[_c('VanImage',{attrs:{"height":"4.266667rem","fit":"cover","src":_vm.path}}),_c('div',{staticClass:"preview"},[_vm._v("点击可查看全图")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }